import { OfbizList, OfbizForm } from "@urbannex/ofbiz-forms";
import { ConfigOptions, getColumnFieldTitles, getFieldSets, getFields, getIdFieldName, getTitleDescriptionField } from "@urbannex/view-containers";
import { FEAT_GROUP_FORMS } from "./forms";

export const featureGroupOptions:ConfigOptions = {
    name:"",
    title:"Feature Group Componment",
    listForm: new OfbizList({
        listType:"grid",
        listFormName:"EditProductFeatureGroups",
        listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
        columnFields:getFields("EditProductFeatureGroups",FEAT_GROUP_FORMS),
        columnFieldTitles:getColumnFieldTitles("EditProductFeatureGroups",FEAT_GROUP_FORMS),
        appContext:"catalog",
        emptyListMessage:"No feature groups currently on system",
        remoteFormData:{
          formData:{
            formName:"EditProductFeatureGroups",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            listType:"grid"
          }
        } 
    }),
    addForm:new OfbizForm({
        formName:"EditProductFeatureGroup",
        formLocation:"component://kwikstore/widget/FeatureForms.xml",
        fields:getFields("EditProductFeatureGroup",FEAT_GROUP_FORMS),
        titleDescriptionField:getTitleDescriptionField("EditProductFeatureGroup",FEAT_GROUP_FORMS),
        idFieldName:getIdFieldName("EditProductFeatureGroup",FEAT_GROUP_FORMS),
        fieldSets:getFieldSets("EditProductFeatureGroup",FEAT_GROUP_FORMS),
    }),
    findForm:undefined,
    settings:[],
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Product Feature Groups",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"EditProductFeatureGroups",
        "data":{
          formData:{
            formName:"EditProductFeatureGroups",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            listType:"grid"
          },
          "endPoint":"catalog",
          "parameters":{"productFeatureGroupId":""}
        }
      },
      addFormText:"Create Feature Group",
      editFormText:"Update Feature Group"
    },
    relations:[]

}